import { render, staticRenderFns } from "./NoticeDetailComponent.vue?vue&type=template&id=1395b446&scoped=true&"
import script from "./NoticeDetailComponent.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailComponent.vue?vue&type=style&index=0&id=1395b446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395b446",
  null
  
)

export default component.exports